import { render, staticRenderFns } from "./ReviewGateAdmin.vue?vue&type=template&id=4e10081e"
import script from "./ReviewGateAdmin.vue?vue&type=script&lang=js"
export * from "./ReviewGateAdmin.vue?vue&type=script&lang=js"
import style0 from "./ReviewGateAdmin.vue?vue&type=style&index=0&id=4e10081e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports